"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$ = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$outboundSchema = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$inboundSchema = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$ = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$outboundSchema = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$inboundSchema = void 0;
exports.getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurityToJSON = getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurityToJSON;
exports.getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurityFromJSON = getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurityFromJSON;
exports.getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequestToJSON = getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequestToJSON;
exports.getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequestFromJSON = getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$;
(function (GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$) {
    /** @deprecated use `GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$inboundSchema` instead. */
    GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$.inboundSchema = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$inboundSchema;
    /** @deprecated use `GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$outboundSchema` instead. */
    GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$.outboundSchema = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$outboundSchema;
})(GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$ || (exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$ = GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$ = {}));
function getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurityToJSON(getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity) {
    return JSON.stringify(exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$outboundSchema
        .parse(getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity));
}
function getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetSecurity' from JSON`);
}
/** @internal */
exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$;
(function (GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$) {
    /** @deprecated use `GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$inboundSchema` instead. */
    GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$.inboundSchema = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$inboundSchema;
    /** @deprecated use `GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$outboundSchema` instead. */
    GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$.outboundSchema = exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$outboundSchema;
})(GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$ || (exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$ = GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$ = {}));
function getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequestToJSON(getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest) {
    return JSON.stringify(exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$outboundSchema
        .parse(getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest));
}
function getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGetRequest' from JSON`);
}
//# sourceMappingURL=getnationalestimatedvaluesstatssalesnationalestimatedvaluesget.js.map